import { AxiosRequestConfig } from 'axios';

import AbstractCRMApi from '../../AbstractCRMApi';
import AdminActivity from '../../Models/AdminActivity';
import UserLogin from '../../Models/UserLogin';
import GetDictionaryResponse from '../Responses/DictionaryResponse';
import GetPaginatedResponse from '../Responses/PaginatedResponse';

class DatabaseLogApi extends AbstractCRMApi {
    public endpoint: string = 'db_log';

    public async getUserLogins(
        userId: number,
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<UserLogin>> {
        return AbstractCRMApi.mapPaginatedDataToModel(
            (
                await this.get(`/user_logins/${userId}`, {
                    ...config,
                    params: { ...config?.params, page },
                })
            ).data,
            UserLogin
        );
    }

    public async getAdminActivities(
        page: number = 1,
        config?: AxiosRequestConfig
    ): Promise<GetPaginatedResponse<AdminActivity>> {
        return AbstractCRMApi.mapPaginatedDataToModel(
            (
                await this.get('/admin_activities', {
                    ...config,
                    params: { ...config?.params, page },
                })
            ).data,
            AdminActivity
        );
    }

    public async getModelNames(): Promise<GetDictionaryResponse> {
        return (await this.get('/model_names')).data;
    }
}

export default new DatabaseLogApi();
